export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspección de calidad"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar inspección de calidad"])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar la inspección de calidad?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality inspect"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destroy"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destroy quality inspect"])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to destroy quality inspection?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        }
      }
    }
  })
}